<template>
  <div
    v-if="showSubmitted"
    class="min-h-screen flex flex-col justify-center fixed bg-gray-900 inset-0"
  >
    <div class="max-w-5xl mx-auto p-4">
      <h2 class="text-5xl md:text-7xl uppercase font-black leading-none">
        <span class="text-red-600">Thank you!</span> your survey was submitted
      </h2>

      <p class="text-2xl mt-10">
        Your answers will help to build a healthier, more active community
      </p>

      <div
        v-if="survey.thank_you_text"
        class="wysiwyg mt-10"
        v-html="$sanitize(survey.thank_you_text)"
      />

      <button
        type="button"
        class="mt-10 flex justify-between items-center w-full sm:w-72 md:w-80 text-left border-4 border-white p-3 my-2 text-2xl font-bold font-display leading-tight focus:outline-none focus:border-orange-700"
        @click="close"
      >
        <span>Close</span>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22 22"
            class="w-8 h-8"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              d="M1 1h20v20H1z"
            />
            <path
              fill="currentColor"
              d="M11.8 16.5c-.3.3-.7.3-.9 0l-5.3-5.3c-.3-.3-.3-.7 0-.9L10.9 5c.3-.3.7-.3.9 0l.6.6c.3.3.3.7 0 .9L9.1 9.7H17c.4 0 .7.3.7.7v.9c0 .4-.3.7-.7.7H9.1l3.3 3.1c.3.3.3.7 0 .9l-.6.5z"
            />
          </svg>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('survey')

export default {
  props: {
    showSubmitted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'survey'
    ])
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
